import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import classNames from 'classnames';
import './index.scss';
import Icons from '../../Icons'

const MultiAccordian = ({ items = [], active, setActive = () => { }, explodedItems = false, allowHeaderClick = true, allowCompletedClick = true, collapsible = true }) => {
    let outerClass = "AccordionRoot"
    if (explodedItems) outerClass += " AccordionRoot-exploded"
    let accordionItemClass = "AccordionItem"
    if (explodedItems) accordionItemClass += " AccordionItem-exploded"
    return (
        <Accordion.Root className={outerClass} type="single" value={active} onValueChange={setActive} collapsible={collapsible}>
            {items.map((item, index) => {
                return <Accordion.Item className={accordionItemClass} value={item.id} key={index}>
                    <AccordionTrigger completed={item.completed} allowCompletedClick={allowCompletedClick} allowHeaderClick={allowHeaderClick}>{item.header}</AccordionTrigger>
                    <AccordionContent>{item.content}</AccordionContent>
                </Accordion.Item>
            })}
        </Accordion.Root>
    )
};

const AccordionTrigger = React.forwardRef(({ children, className, completed = false, allowCompletedClick = true, allowHeaderClick = true, ...props }, forwardedRef) => (
    <Accordion.Header className="AccordionHeader">
        {!completed && !allowHeaderClick && <div className={classNames('AccordionTrigger', className)} {...props}>
            {children}
            <Icons icon="chevronDown" className="accordionIcon" color="#7C8086" />
        </div>}

        {!completed && allowHeaderClick && <Accordion.Trigger
            className={classNames('AccordionTrigger', className)}
            {...props}
            ref={forwardedRef}
        >
            {children}
            <Icons icon="chevronDown" className="accordionIcon" color="#7C8086" />
        </Accordion.Trigger>}
        {(completed && !allowCompletedClick) && <div className={classNames('AccordionTrigger', className)} >
            {children}
            <div style={{ color: "#319B90", display: "flex", gap: "4px" }} className="text-heavy text-sml">
                <Icons icon="tickCircle" color="#319B90" style={{ display: "flex" }} />
                <div>Done</div>
            </div>
        </div>}
        {completed && allowCompletedClick && <Accordion.Trigger
            className={classNames('AccordionTrigger', className)}
            {...props}
            ref={forwardedRef}
        >
            {children}
            <div style={{ color: "#319B90", display: "flex", gap: "4px" }} className="text-heavy text-sml">
                <Icons icon="tickCircle" color="#319B90" style={{ display: "flex" }} />
                <div>Done</div>
            </div>
        </Accordion.Trigger>}

    </Accordion.Header>
));

const AccordionContent = React.forwardRef(({ children, className, ...props }, forwardedRef) => (
    <Accordion.Content
        className={classNames('AccordionContent', className)}
        {...props}
        ref={forwardedRef}
    >
        <div className="AccordionContentText">{children}</div>
    </Accordion.Content>
));

export default MultiAccordian;